module.exports = __webpack_public_path__ + "ba71b7c05442d2f158b9bd0912c7d8a1.png";